import { ChangeControllerSettingsAction } from '../enums/action';
import { OWNER_ROLE, ROLES } from './roles';

//TODO
//Rewrite Actions Access by Role
export const CONTROLLER_CUSTOMER_ACTIONS: ChangeControllerSettingsAction[] = [];

export const CONTROLLER_OPERATOR_ACTIONS: ChangeControllerSettingsAction[] = [
  ...CONTROLLER_CUSTOMER_ACTIONS,
  ChangeControllerSettingsAction.SET_COOLING_SPREAD_CONTROL,
  ChangeControllerSettingsAction.PID_GAINS_CHANGE_P,
  ChangeControllerSettingsAction.PID_GAINS_CHANGE_I,
  ChangeControllerSettingsAction.PID_GAINS_CHANGE_D,
  ChangeControllerSettingsAction.SET_SHUNT_TRIP,
  ChangeControllerSettingsAction.RESET_TC_ASSIGNEMENTS,
  ChangeControllerSettingsAction.CLEAR_ALL_CHANNELS_NAMES,
  //power sharing
  ChangeControllerSettingsAction.POWER_SHARING_ENABLE,
  ChangeControllerSettingsAction.POWER_SHARING_AMPERAGE,
  ChangeControllerSettingsAction.FULL_POWER_ALLOWING,
  ChangeControllerSettingsAction.PRE_HEAT_RUN_WITH_FAULT,
  ChangeControllerSettingsAction.CHANNEL_CONSOLE_4_6,
  ChangeControllerSettingsAction.CHANNEL_CONSOLE_2_12,
  ChangeControllerSettingsAction.CHANNEL_CONSOLE_1_18,
  ChangeControllerSettingsAction.CHANNEL_CONSOLE_1_12_GEN,
];

export const CONTROLLER_SUPERVISOR_ACTIONS: ChangeControllerSettingsAction[] = [...CONTROLLER_OPERATOR_ACTIONS];

export const CONTROLLER_OWNER_ONLY_ACTIONS: ChangeControllerSettingsAction[] = [
  ...CONTROLLER_SUPERVISOR_ACTIONS,
  ChangeControllerSettingsAction.RESET_FAULT,
  ChangeControllerSettingsAction.FACTORY_RESET,
];

export const CONTROLLER_ACTIONS_BY_ROLE = {
  [OWNER_ROLE]: CONTROLLER_OWNER_ONLY_ACTIONS,
  [ROLES.SUPERVISOR]: CONTROLLER_SUPERVISOR_ACTIONS,
  [ROLES.OPERATOR]: CONTROLLER_OPERATOR_ACTIONS,
  [ROLES.CUSTOMER]: CONTROLLER_CUSTOMER_ACTIONS,
};
